<template>
  <Layout :indexStyle="indexStyle">
    <CustomHeader v-if="isCustomHeader"></CustomHeader>

    <div class="open-app-tips" v-if="isOpenTip" ref="openAppTips">
      <wownow-image class="app-icon" src="https://img.tinhnow.com/wownow/files/pro/app/MEF/BF/BD/91f60168c9a44fb491440e9f75f82984.png" alt="" />
      <span class="open-text">{{ $t('global.shareText') }}</span>
      <wxOpenAppLayout
        :style="{display:'flex'}"
        :comId="`lauch-btn-main`"
        :extinfoProps="$root.getWxApproute()">
        <span class="open-btn" @click="goAppPage">{{ $t('global.openApp') }}</span>
      </wxOpenAppLayout>
    </div>
    <div class="open-app-tips-div" :style="openAppTipsDivStyle"  v-if="isOpenTip" />
    <div class="have-background-img position-relative" v-if="pageBackgroundPic" v-show="isLoadingCms">
      <ThemeBannerRuleButton :rule="rule" v-if="cmsData && cmsData.pageDescriptionStyle === '10'" v-show="isLoadingCms" />
      <wownow-image :src="pageBackgroundPic" class="background-img" />

      <div class="background-site">
        <div class="position-relative scroll-touch">
          <LoadingCms :pageLable="$root.pageLabel" @load="loadCMS" v-if="!isWait" />
          <Empty v-if="isLoadingCms && !this.cmsData" />
        </div>
      </div>
    </div>
    <div v-else class="position-relative"  v-show="isLoadingCms">
      <ThemeBannerRuleButton :rule="rule" v-if="cmsData && cmsData.pageDescriptionStyle === '10'" v-show="isLoadingCms" />
      <LoadingCms :pageLable="$root.pageLabel" @load="loadCMS" v-if="!isWait" />
      <Empty v-if="isLoadingCms && !this.cmsData" />
    </div>
    <transition name="slide-fade">
      <OpenStep  v-model="$root.isShowMasking" />
    </transition>
  </Layout>
</template>

<script>
import OpenStep from '$common/components/open-step/open-step.vue';
import WxOpenLaunchAppLocal from '$common/components/wechat/wx-open-launch-app-local';
import Layout from './components/layout';
import storage from '$common/utils/storage';
import { pageEvent } from '$common/utils/event-tracking/page';
import Empty from './components/empty';
import CustomHeader from './components/layout/custom-header.vue';
import LoadingCms from '$common/components/cms-components/plus-components/loading-cms';
import ThemeBannerRuleButton from '$common/components/cms-components/components/theme-banner-rule-button';
import { getWechatAppId } from '$common/utils/common'
export default {
  components: {
    Layout, LoadingCms, ThemeBannerRuleButton, Empty, WxOpenLaunchAppLocal, OpenStep,
    CustomHeader
  },
  documentTitle: 'WOWNOW',
  data() {
    return {
      defaultBackgroundColor: 'background: #FF6157;',
      isLoadingCms: false,
      getOperatorNoCount: 0,
      pageShareInfo: undefined,
      isSetPageEvent: false,
      isWait: true,
      filterCardsLoadingNames: ['cmsGoods', 'cmsStore']
    };
  },
  computed: {
    wxGoAppRouter() {
      let routePath = window.location.href;
      return `${routePath}`;
    },
    cmsData() {
      return this.$root.user.cmsData;
    },
    openAppTipsDivStyle() {
      if (!this.isWownowApp && this.$refs.openAppTips && this.isLoadingCms) {
        const height = this.$root.getHeight(this.$refs.openAppTips);
        return `height: ${height}px;`
      }
      return '';
    },
    isWownowApp() {
      return this.$root.isWownowApp
    },
    isOpenTip() {
      if (this.$root.isNotTip) return false
      return !this.$root.isWownowApp
    },
    isCustomHeader() {
      return this.$root.isCustomHeader
    },
    shareDefault() {
      const __language = this.$i18n.locale;
      return {
        title: __language.indexOf('zh') !== -1 && '使用WOWNOW，大大惊喜等着你' ||
          __language.indexOf('km') !== -1 && 'ប្រើប្រាស់WOWNOW ការភ្ញាក់ផ្អើលដ៏ធំមួយកំពុងរង់ចាំអ្នក' || 'Using WOWNOW a big surprise waiting for you',
        content: window.location.href,
        imgUrl: 'https://img.tinhnow.com/wownow/static/img/share-logo.png',
        desc: __language.indexOf('zh') !== -1 && 'WOW,生活无处不惊喜' ||
          __language.indexOf('km') !== -1 && 'WOW ភ្ញាក់ផ្អើលគ្រប់ទីកន្លែង' || 'WOW Surprise everywhere',
      };
    },
    rule() {
      return {
        title: this.$t('global.ruleLabel'),
        content: this?.cmsData?.pageDescription ?? '',
        fontColor: this?.cmsData?.pageDescriptionColor ?? '',
        backgroundColor: this?.cmsData?.pageDescriptionBgColor ?? ''
      }
    },
    pageBackgroundPic() {
      if (this?.cmsData?.pageBackground) {
        return this.cmsData.pageBackground;
      }
      return '';
    },
    pageName() {
      return this?.cmsData?.pageName ?? '';
    },
    indexStyle() {
      if (this?.cmsData?.pageColor) {
        return `background-color: ${this?.cmsData?.pageColor};`;
      }
      return this.defaultBackgroundColor;
    },
    cmsDataTrue() {
      return this && this.cmsData && this.cmsData.cards && this.cmsData.cards.length;
    },
    goodsCardList() {
      return this.cmsDataTrue ? this.cmsData.cards.filter(e => this.filterCardsLoadingNames.filter(q => q === e.cardModelLabel).length) : [];
    }
  },
  created() {
    console.log('wechatAppid',this.$root.wechatAppid)
  },
  watch: {
    pageName(val) {
      this.$root.updateDocumentTitle(val);
    },
    isLoadingCms(val) {
      if (val) {
        Vue.filter('loading')(false);
        this.$root.timeout(() => {
          if (this.goodsCardList.length && !(this?.$root?.user?.commodity?.list?.length ?? 0) && this.$root.pageLabel && !(this.$root?.user?.commodity?.isSetBossPosition)) {
            Vue.filter("message-popup")(true, {
              msg: this.$t('global.outOfScope'),
              ok: () => {
                this.$root.user.commodity.isSetBossPosition = true;
                this.$set(this.$root.user.commodity, 'list', [])
                if (this?.cmsData?.pageAddress) {
                  this.$set(this.$root.user, 'position', this.cmsData.pageAddress);
                  this.$nextTick(() => this.$root.resetCurrent());
                }
              },
              okTxt: this.$t('global.switchPositioning')
            })
          }
        }, 3000);
      }
    }
  },
  async mounted() {
    if (this.$root.isWownowApp) {
      let isContinue = true;
      let count = 0;
      do {
        if (count >= 3) {
          isContinue = false;
        }
        ++count;
        try {
          if (this.$root.isWownowApp) {
            if (window?.WOWNOW?.getUserInfo) {
              if (!window.subLanguage) {
                await this.$root.loadingWownowLanguage();
              } else {
                isContinue = false;
                break;
              }
            } else {
              await new Promise(re => this.$root.timeout(() => re(), 50));
            }
          }
        } catch(error) {}
      } while(isContinue);
    }

    this.isWait = false;
    Vue.filter('go-h5', (__url) => {
      // 安卓的微信里打开app成功的话不走接下来的步骤
      if(this.$root.isWechat && this.$root.isAndroid && this.$root.successWxOpenApp) {
        // this.$root.isShowMasking = true
        return
      }
      let jumpRoute = this.$root.getJumpUrl(__url)
      if(jumpRoute?.navigationToRoute) {
        window?.WOWNOW?.navigationToRoute({ route: jumpRoute.navigationToRoute })
        return
      }
      if(jumpRoute) {
        window.location.href = jumpRoute
        return
      }
    });
    if (this.$root.pageLabel) {
      Vue.filter('loading')(true);
    } else {
      this.isLoadingCms = true;
    }
    this.$root.timeout(() => {
      if (this.$root.isWownowApp) {
        this.goBack();
        this.getOperatorNo();
      }
    }, 50);
  },
  methods: {
    launchSuccess() {
      console.log('launchSuccess')
    },
    goAppPage() {
      Vue.filter('go-h5')();
    },
    getOperatorNo() {
      if (this.$root.isWownowApp) {
        ++this.getOperatorNoCount;
        console.log('window?.WOWNOW?.getUserInfo!')
        window?.WOWNOW?.getUserInfo({
          success: res => {
            if (res && res.loginName) {
              this.$root.user.wownowLogin = true;
              storage.setItem('loginName', res.loginName)
              storage.setItem('operatorNo', res.operatorNo)
            }
          },
          fail: res => {
            this.$root.user.wownowLogin = false;
            window?.WOWNOW?.navigationToRoute({
              route: "SuperApp://SuperApp/login"
            });
          },
          complete: res => {
            this.$root.timeout(() => {
              if (!this.$root.user.wownowLogin) {
                if (this.getOperatorNoCount < 3) {
                  this.getOperatorNo();
                  return;
                }
                window?.WOWNOW?.navigationToRoute({
                  route: "SuperApp://SuperApp/login"
                });
              }
            }, 50);
          }
        });
        this.$root.user.addNavRightButtonNum = parseInt(Math.random() * 100000, 10);
        window?.WOWNOW?.removeAllNavButton()
        window?.WOWNOW?.addNavRightButton({
          imageBase64: 'data:image/png;base64,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',
          id: this.$root.user.addNavRightButtonNum
        });
        this.$root.timeout(() => {
          window?.webViewHost?.on('navigationBar.rightButton.onclick', ({ id }) => {
            if (this.$root.user.addNavRightButtonNum.toString() === id.toString()) {
              const pageShareInfo = {};
              if (this.pageShareInfo) {
                pageShareInfo.title = this.$i18n.locale === 'zh' ? this.pageShareInfo.pageShareCnName : (this.$i18n.locale === 'km' ? this.pageShareInfo.pageShareKhName : this.pageShareInfo.pageShareEnName);
                pageShareInfo.desc = this.$i18n.locale === 'zh' ? this.pageShareInfo.pageShareCnDescription : (this.$i18n.locale === 'km' ? this.pageShareInfo.pageShareKhDescription : this.pageShareInfo.pageShareEnDescription);
              }
              const short = window.ssrConfig?.routerConfig?.short ?? {};
              const title = short?.[`${this.$i18n.locale}ShareTitle`] || pageShareInfo?.title || short?.enShareTitle || '';
              const desc = short?.[`${this.$i18n.locale}ShareTips`] || pageShareInfo?.desc || short?.enShareTips || ''
              const shareLogo = this?.pageShareInfo?.pageShareImage ?? short?.shareLogo ?? '';
              const content = (short?.shortID ?? '') ? `${window.location.origin}/${short.shortID}` : window.location.href;
              window?.WOWNOW?.socialShare({
                title: title || this.shareDefault.title,
                image: shareLogo || this.shareDefault.imgUrl,
                content,
                desc,
                success: (res) => Vue.filter('show-message')({ content: this.$t('global.shareSuccess'), closeTime: 15000, type: 'success' }),
                fail: (res) => Vue.filter('show-message')({ content: this.$t('global.shareFail'), closeTime: 15000 })
              });
            }
          })
        }, 300);
      }
    },
    loadCMS(cmsData) {
      console.log('cmsData: ', cmsData)
      this.isLoadingCms = true;
      cmsData && cmsData.cards && cmsData.cards.length && this.$set(this.$root.user, 'cmsData', cmsData);
      if (this?.cmsData?.pageShareInfo) {
        this.pageShareInfo = this.cmsData.pageShareInfo;
      }
      if (!this.isSetPageEvent) {
        this.isSetPageEvent = true;
        this.$root.timeout(() => {
          pageEvent({
            businessName: this.pageName || 'cms-h5-page-v2'
          });
        }, 10);
      }
    },
    goBack() {
      window?.WOWNOW?.setWebViewBackStyle({
        style: 'goBack',
        success: () => { }
      });
      window?.WOWNOW?.enableWebViewGesture({
        enable: 0,
        success: (res) => {}
      });
    }
  }
}
</script>

<style lang="stylus" scoped>
  .open-app-tips-div {
    width: 100%;
    height: 50px;
  }
  .background-img {
    width: 100%;
  }
  .have-background-img {
    overflow hidden
    width: 100%;
    height: 100%;
  }
  .background-site {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    overflow hidden
    font-size: 0
  }
  .open-app-tips {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    padding: 5px 10px;
    background-color: #fff;
    display: flex;
    align-items: center;
    z-index: 4000;

    .app-icon {
      width: 40px;
      height: 40px;
      margin-right: 6px;
    }
    .open-text {
      flex: 1;
      padding-right: 10px;
      font-size: 14px;
      font-family: PingFangTC-Regular, PingFangTC;
      font-weight: 400;
      color: #333333;
      line-height: 1.5;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3; /* 这里是超出几行省略 */
      overflow: hidden;
    }
    .open-btn {
      display: inline-block;
      padding: 7px 12px;
      text-align: center;
      white-space: nowrap;
      font-size: 12px;
      font-family: PingFangTC-Regular, PingFangTC;
      font-weight: 400;
      color: #FFFFFF;
      background: #FC2040;
      border-radius: 3px;
    }
  }
</style>
<style lang="stylus" scoped>


/* 可以设置不同的进入和离开动画 */
/* 设置持续时间和动画函数 */
.slide-fade-enter-active {
  transition: opacity .5s;
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: opacity .5s;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  opacity: 0;
}
.masking {
  position: fixed;
  top: 0;
  left: 0;
  overflow: hidden;
  width: 100vw;
  height: 100vh;
  background-color: rgba(46, 45, 45, 0.8);
  z-index: 9000
}

</style>
